// Official Luminart "LP" monogram — vector-traced from the brand logo (exact outline).
const LOGO_PATH =
  "M106.90 64.00 c-2.50 1.30 -4.40 3.40 -5.80 6.40 l-2.20 4.40 l0.30 117.80 c0.40 132.80 -0.20 122.20 8.30 139.90 c7.90 16.30 19.60 28.00 36.00 36.00 c16.60 8.10 16.10 8.00 90.50 7.90 c65.10 -0.00 65.50 -0.00 70.30 -2.20 c7.90 -3.50 12.30 -7.70 15.90 -15.00 l3.30 -6.70 l0.50 -38.50 l0.50 -38.50 l2.60 -5.60 c3.40 -7.20 9.00 -12.80 16.50 -16.50 l5.90 -2.90 l61.50 -0.60 c57.50 -0.50 62.00 -0.70 68.50 -2.60 c33.80 -9.70 57.00 -34.20 63.90 -67.50 c2.70 -13.30 1.90 -32.90 -2.00 -44.60 c-7.70 -23.10 -23.60 -41.70 -44.90 -52.20 c-18.30 -9.00 -10.90 -8.40 -106.80 -8.70 l-84.80 -0.40 l-4.00 2.30 c-7.50 4.20 -10.10 15.00 -5.20 21.70 c1.10 1.40 3.90 3.60 6.30 4.80 l4.40 2.30 l80.60 -0.00 c88.80 -0.00 86.30 -0.20 98.40 6.30 c3.30 1.80 9.00 6.20 12.70 9.90 c17.40 17.60 21.70 44.30 10.70 66.80 c-4.30 9.00 -16.00 20.60 -24.90 24.80 c-12.50 6.00 -15.30 6.20 -76.20 6.20 c-51.50 -0.00 -55.70 0.10 -63.40 2.00 c-20.00 4.80 -35.60 17.30 -44.40 35.50 c-6.30 13.00 -6.90 17.50 -6.90 55.70 l0.00 33.80 l-59.20 -0.00 c-64.50 -0.00 -67.60 -0.30 -78.80 -5.70 c-6.70 -3.20 -16.60 -13.10 -19.90 -19.70 c-5.20 -10.70 -5.10 -6.50 -5.10 -130.70 l0.00 -115.60 l-2.30 -4.30 c-4.00 -7.50 -13.00 -10.10 -20.80 -6.00 Z";

const VIEWBOX = "90 50 470 344";

// `draw` runs the cinematic "glowing-lines → assemble" opening.
// `fillOn` (state-driven) fades the solid mark in — immune to React re-renders.
export const LuminartLogo = ({
  className = "w-24 h-auto",
  draw = false,
  glow = true,
}) => {
  return (
    <svg
      viewBox={VIEWBOX}
      className={className}
      role="img"
      aria-label="Luminart Projection logo"
    >
      <defs>
        <filter id="lum-glow" x="-40%" y="-40%" width="180%" height="180%">
          <feGaussianBlur stdDeviation="5" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {draw ? (
        <g filter={glow ? "url(#lum-glow)" : undefined}>
          {/* Phase 1 — traced glowing lines */}
          <path
            className="lum-stroke"
            pathLength="1"
            d={LOGO_PATH}
            fill="none"
            stroke="#ffffff"
            strokeWidth="2.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          {/* Phase 2 — solid mark assembles */}
          <path className="lum-fill" d={LOGO_PATH} fill="#ffffff" stroke="none" />
        </g>
      ) : (
        <path
          d={LOGO_PATH}
          fill="#ffffff"
          stroke="none"
          filter={glow ? "url(#lum-glow)" : undefined}
        />
      )}
    </svg>
  );
};

export default LuminartLogo;
